import React from 'react';
import { Link, useParams } from 'react-router';
import { Helmet } from '@dr.pogodin/react-helmet';
import dayjs from 'dayjs';

import Main from '../layouts/Main';
import Markdown from '../components/Looseleafs/Markdown';
import { getPost } from '../data/looseleafs';
import NotFound from './NotFound';

const Looseleaf = () => {
  const { slug } = useParams();
  const post = getPost(slug);

  // An unknown slug is a genuine 404, not an empty post page.
  if (!post) return <NotFound />;

  return (
    <Main>
      <Helmet
        title={post.title}
        meta={post.summary ? [{ name: 'description', content: post.summary }] : []}
      />
      <article className="post" id="looseleaf">
        <header>
          <div className="title">
            <h2><Link to={`/looseleafs/${post.slug}`}>{post.title}</Link></h2>
            <time className="published" dateTime={post.date}>
              {dayjs(post.date).format('MMMM D, YYYY')}
            </time>
          </div>
        </header>
        <Markdown>{post.body}</Markdown>
        <p className="looseleaf-back"><Link to="/looseleafs">Back to all posts</Link></p>
      </article>
    </Main>
  );
};

export default Looseleaf;
